/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Github_DescInputs */

const en_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`open source`)
};

const ar_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مفتوح المصدر`)
};

const bn_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওপেন সোর্স`)
};

const de_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Source`)
};

const es_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`código abierto`)
};

const fr_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projets open source`)
};

const pt_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`código aberto`)
};

const zh_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源`)
};

const tr_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`açık kaynak`)
};

const ru_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`с открытым исходным кодом`)
};

const pl_hero_github_desc = /** @type {(inputs: Hero_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oprogramowanie open source`)
};

/**
* | output |
* | --- |
* | "open source" |
*
* @param {Hero_Github_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_github_desc = /** @type {((inputs?: Hero_Github_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Github_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_github_desc(inputs)
	if (locale === "bn") return bn_hero_github_desc(inputs)
	if (locale === "de") return de_hero_github_desc(inputs)
	if (locale === "es") return es_hero_github_desc(inputs)
	if (locale === "fr") return fr_hero_github_desc(inputs)
	if (locale === "pt") return pt_hero_github_desc(inputs)
	if (locale === "zh") return zh_hero_github_desc(inputs)
	if (locale === "tr") return tr_hero_github_desc(inputs)
	if (locale === "ru") return ru_hero_github_desc(inputs)
	if (locale === "pl") return pl_hero_github_desc(inputs)
	return en_hero_github_desc(inputs)
});